import React from "react";
import { Badge } from "@chakra-ui/react";

/**
 * Renders a Chakra Badge styled from a {bg, color, border} scheme object.
 * Schemes come from paymentsConstants and carry the original status/provider colors.
 * @param {Object} props - Badge props
 * @param {Object} props.scheme - Color scheme with bg, color and border keys
 * @param {string} props.label - Badge text
 * @returns {React.ReactElement}
 */
function SchemeBadge({ scheme, label, ...rest }) {
    return (
        <Badge bg={scheme.bg} color={scheme.color} border="1px solid" borderColor={scheme.border}
            borderRadius="full" px="8px" py="2px" fontSize="0.7rem" fontWeight="600" textTransform="none" {...rest}>
            {label}
        </Badge>
    );
}

export default SchemeBadge;
